import { useState } from "react";
import SectionTitle from "@/components/feature/SectionTitle";

const faqs = [
  {
    q: "91韩漫画的分类是怎么划分的？",
    a: "我们按题材将韩漫精细划分为校园、奇幻、都市、恋爱、悬疑等大类，每一部作品都根据主线剧情归入最贴合的分类，方便你按口味直接定位。想看特定类型的韩漫，进分类就能找到，不用全网乱搜。",
  },
  {
    q: "想看某个题材的韩漫，应该从哪个入口进入？",
    a: "首页顶部导航和首页的「分类导航」板块都提供了各题材入口，点击对应分类即可浏览该题材下的全部作品，并支持按人气、评分、最新等维度排序筛选。",
  },
  {
    q: "漫画的更新频率如何？",
    a: "每部作品在详情页会标注「连载中」或「已完结」状态，连载中的作品会展示最近话更新与更新时间，首页「最新更新」板块会同步汇总当日更新内容，方便追更。",
  },
  {
    q: "评分和人气数据是怎么来的？",
    a: "评分由读者的真实收藏与阅读反馈综合计算，人气依据浏览量累计生成。我们每部作品都清晰展示评分、阅读量和章节数，帮你快速判断作品的热度与口碑。",
  },
  {
    q: "收藏的作品可以在哪里查看？",
    a: "在作品详情页点击「加入书架」即可收藏，方便随时回到上次看到的地方继续追更，管理你的追漫列表。",
  },
  {
    q: "站内内容可以免费阅读吗？",
    a: "我们致力于提供便捷的韩漫资讯与分类导航服务，站内展示的内容以分类、推荐和目录信息为主，具体阅读体验请以各作品详情页提示为准。",
  },
];

export default function FaqSection({ withHeading = true }: { withHeading?: boolean }) {
  const [open, setOpen] = useState(0);

  return (
    <section className="section-pad bg-background-100">
      <div className="container-x max-w-4xl">
        {withHeading && (
          <SectionTitle
            kicker="FAQ"
            title="读者常见问题"
            desc="关于分类、更新、评分与收藏的疑问，这里都有答案。"
          />
        )}
        <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
          {faqs.map((f, i) => (
            <div key={f.q}>
              <button
                type="button"
                onClick={() => setOpen(open === i ? -1 : i)}
                aria-expanded={open === i}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="flex items-center gap-3 text-sm font-semibold text-foreground-950">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                    {i + 1}
                  </span>
                  {f.q}
                </span>
                <i
                  className={`text-lg text-foreground-400 transition-transform duration-300 ${
                    open === i ? "rotate-180 text-primary-500" : ""
                  } ${open === i ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}`}
                />
              </button>
              <div
                className={`grid transition-all duration-300 ${
                  open === i ? "grid-rows-[1fr] pb-4 opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-14 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}